import { render, staticRenderFns } from "./doorPointInformation.vue?vue&type=template&id=6f695479&scoped=true&"
import script from "./doorPointInformation.vue?vue&type=script&lang=js&"
export * from "./doorPointInformation.vue?vue&type=script&lang=js&"
import style0 from "./doorPointInformation.vue?vue&type=style&index=0&id=6f695479&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f695479",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f695479')) {
      api.createRecord('6f695479', component.options)
    } else {
      api.reload('6f695479', component.options)
    }
    module.hot.accept("./doorPointInformation.vue?vue&type=template&id=6f695479&scoped=true&", function () {
      api.rerender('6f695479', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/doorPointInformation.vue"
export default component.exports